import { useId } from 'react';
import { SVGProps } from '../types';

const AgentGimbalIcon = (props: SVGProps) => {
  const maskId = useId();

  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <mask
        id={`${maskId}-horizontal`}
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="-3"
        y="-3"
        width="22"
        height="22"
      >
        <path d="M19 -3H-3V19H19V-3Z" fill="white" />
        <path
          d="M5.68 10.05L7.7 12.79"
          stroke="black"
          strokeWidth="2.95"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.3 3.20996L10.32 5.94996"
          stroke="black"
          strokeWidth="2.95"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </mask>
      <g mask={`url(#${maskId}-horizontal)`}>
        <path
          d="M9.08636 10.6888C12.4148 9.34404 14.6267 7.05004 14.0267 5.56504C13.4267 4.08004 10.2421 3.96637 6.91364 5.31115C3.58519 6.65593 1.37333 8.94993 1.9733 10.4349C2.57328 11.9199 5.75791 12.0336 9.08636 10.6888Z"
          stroke="currentColor"
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <mask
        id={`${maskId}-vertical`}
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="-3"
        y="-3"
        width="22"
        height="22"
      >
        <path d="M19 -3H-3V19H19V-3Z" fill="white" />
        <path
          d="M10.17 10.32L12.99 8.42004"
          stroke="black"
          strokeWidth="2.95"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3.01 7.58005L5.83 5.68005"
          stroke="black"
          strokeWidth="2.95"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </mask>
      <g mask={`url(#${maskId}-vertical)`}>
        <path
          d="M5.3935 9.27131C6.96719 12.4978 9.40988 14.5443 10.8494 13.8422C12.2889 13.1401 12.1802 9.9553 10.6065 6.72876C9.03282 3.50222 6.59012 1.45577 5.15059 2.15787C3.71106 2.85998 3.81981 6.04477 5.3935 9.27131Z"
          stroke="currentColor"
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <path
        d="M8 9.10002C8.60751 9.10002 9.1 8.60754 9.1 8.00002C9.1 7.39251 8.60751 6.90002 8 6.90002C7.39249 6.90002 6.9 7.39251 6.9 8.00002C6.9 8.60754 7.39249 9.10002 8 9.10002Z"
        fill="currentColor"
      />
    </svg>
  );
};

export { AgentGimbalIcon };
